/* ============================================================
   wow.js — WOW marketing layer (2026-07-31)
   Additive only: loaded deferred after main.js.
   - Count-up stat band (IntersectionObserver, once-only)
   - Light Engine bar reveal (IntersectionObserver, once-only)
   Both respect prefers-reduced-motion: final values show
   immediately with no animation. No-JS = everything visible.
   ============================================================ */
(function () {
  'use strict';

  var reduced = false;
  try {
    reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { reduced = false; }

  var hasIO = 'IntersectionObserver' in window;

  /* ---------- Light Engine bars ----------
     CSS default: bars fully visible. When motion is allowed we arm
     the animation (.le-anim hides the bars), then reveal (.inview)
     once the section enters the viewport. */
  var engines = document.querySelectorAll('.le-engine');
  if (engines.length) {
    if (reduced || !hasIO) {
      engines.forEach(function (el) { el.classList.add('inview'); });
    } else {
      engines.forEach(function (el) { el.classList.add('le-anim'); });
      var barIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('inview');
            barIO.unobserve(en.target);
          }
        });
      }, { threshold: 0.3 });
      engines.forEach(function (el) { barIO.observe(el); });
    }
  }

  /* ---------- Count-up stats ---------- */
  var counters = document.querySelectorAll('.wow-count');
  if (!counters.length) { return; }

  function setFinal(el) {
    el.textContent = String(el.getAttribute('data-target'));
  }

  /* Reduced motion or no IO: show final numbers immediately. */
  if (reduced || !hasIO) {
    counters.forEach(setFinal);
    return;
  }

  function animate(el) {
    var target = parseInt(el.getAttribute('data-target'), 10);
    if (isNaN(target)) { return; }
    var duration = 1500;
    var start = null;
    el.textContent = '0';
    function tick(now) {
      if (start === null) { start = now; }
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3); /* easeOutCubic */
      el.textContent = String(Math.round(target * eased));
      if (t < 1) {
        window.requestAnimationFrame(tick);
      } else {
        el.textContent = String(target);
      }
    }
    window.requestAnimationFrame(tick);
  }

  /* One observer per stat band; when a band enters view, run all of
     its counters exactly once. */
  var bands = document.querySelectorAll('.wsb');
  if (!bands.length) {
    counters.forEach(setFinal);
    return;
  }
  var countIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.querySelectorAll('.wow-count').forEach(animate);
        countIO.unobserve(en.target);
      }
    });
  }, { threshold: 0.35 });
  bands.forEach(function (el) { countIO.observe(el); });
})();

/* 2026-07-31 sticky waitlist bar: show after the hero scrolls away, hide near the order form */
(function () {
  var bar = document.getElementById('sticky-wait');
  if (!bar) return;
  var hero = document.querySelector('.hero');
  var order = document.getElementById('order') || document.querySelector('[id*="order"], .order, .waitlist-form');
  var pastHero = false, nearOrder = false;
  function update() { bar.classList.toggle('show', pastHero && !nearOrder); }
  if ('IntersectionObserver' in window) {
    if (hero) new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; update(); }, {threshold: 0}).observe(hero);
    if (order) new IntersectionObserver(function (e) { nearOrder = e[0].isIntersecting; update(); }, {threshold: 0}).observe(order);
    if (!order) nearOrder = false;
  } else {
    window.addEventListener('scroll', function () {
      pastHero = hero ? (hero.getBoundingClientRect().bottom < 0) : true;
      nearOrder = order ? (order.getBoundingClientRect().top < innerHeight) : false;
      update();
    }, {passive: true});
  }
})();
